/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
export function validatePassword (text) {
  // 密码规则：必须包含大写字母、小写字母、数字、特殊字符，且长度不少于8位
  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
  if (!reg.test(text)) {
    return {
      flag: false,
      message: '密码至少8个字符，须包含大写字母、小写字母、数字和特殊字符'
    }
  } else {
    return {
      flag: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js